var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,3l6,6l6-6"}));
}

ChevronDownInline.defaultProps = {"className":"stroke","viewBox":"0 0 12 12"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
